export default {
      id: "oc-menu-meter-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-menu-meter",
      toString: function () {
        return this.url;
      }
    }